import Cookies from 'js-cookie';

const affiliateId_KEY = 'affiliateId';
const affiliateName_KEY = 'affiliateName';
const COOKIE_EXPIRY_DAYS = 15;

export const setAffiliateData = (affiliateId, affiliateName) => {
  if (affiliateId) {
    Cookies.set(affiliateId_KEY, affiliateId, { expires: COOKIE_EXPIRY_DAYS });
  }
  if (affiliateName) {
    Cookies.set(affiliateName_KEY, affiliateName, { expires: COOKIE_EXPIRY_DAYS });
  }
};

export const getAffiliateData = () => {
  return {
    affiliateId: Cookies.get(affiliateId_KEY) || '',
    affiliateName: Cookies.get(affiliateName_KEY) || '',
  };
};
